import { createTheme } from '@mui/material';
import { frFR } from '@mui/material/locale';

export const darkMuiTheme = createTheme(
    {
        typography: {
            fontFamily: ['Inter', 'Geist Sans', 'SF Pro Text', 'system-ui', '-apple-system', 'Segoe UI', 'Roboto', 'sans-serif'].join(','),
            fontSize: 12,
        },
        palette: {
            mode: 'dark',
            primary: { main: '#fff' },
            secondary: { main: 'rgb(85, 219, 198)' },
        },
        shape: {
            borderRadius: 10,
        },
        components: {
            MuiTypography: {
                styleOverrides: {
                    h1: {
                        fontWeight: 600,
                    },
                    h2: {
                        fontWeight: 600,
                    },
                    h3: {
                        fontWeight: 500,
                    },
                },
            },
        },
    },
    frFR
);
